import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import {
  CoreQuestionsFactoryService,
  FormQuestionsService,
  AdaCustomizationsService,
  CountriesService
} from 'core/services';
import { QuestionBase } from 'core/components/forms';
import { UntypedFormGroup } from '@angular/forms';
import { DefaultDataQuestionsService } from './default-data-questions.service';
import { MarsDataQuestionsService } from './mars-data-questions.service';

@Injectable()
export class GroupDataQuestionsService implements FormQuestionsService {
  protected delegatedQuestionsService: DefaultDataQuestionsService;
  protected questionsSubject = new BehaviorSubject<any>(null);
  protected formData: any = {};
  protected form: UntypedFormGroup;
  protected gameChange = new Subject<any>();
  protected questionsMap: any;
  protected currentDelegated: string;

  constructor(
    protected factory: CoreQuestionsFactoryService,
    protected countries: CountriesService,
    protected customizations: AdaCustomizationsService,
    protected translateService: TranslateService,
    protected defaultQuestions: DefaultDataQuestionsService,
    protected marsQuestions: MarsDataQuestionsService
  ) {
    this.gameChange.subscribe((params) => this.onGameChanged(params));
    this.questionsMap = {
      default: this.marsQuestions,
      mars: this.marsQuestions
    };
  }

  onGameChanged(params: any = {}) {
    const { group, course } = params;
    let gameKey = group?.gameName
      ? group.gameName.toLowerCase()
      : course?.gameName
      ? course.gameName.toLowerCase()
      : 'default';
    if (!this.questionsMap[gameKey]) {
      gameKey = 'default';
    }
    if (gameKey !== this.currentDelegated) {
      this.setDelegatedQuestionsService(params);
      this.createQuestions(params);
    }
  }

  setDelegatedQuestionsService(params: any = {}) {
    const { group, course } = params;
    let gameKey = group?.gameName
      ? group.gameName.toLowerCase()
      : course?.gameName
      ? course.gameName.toLowerCase()
      : 'default';
    if (!this.questionsMap[gameKey]) {
      gameKey = 'default';
    }
    this.currentDelegated = gameKey;
    this.delegatedQuestionsService = this.questionsMap[gameKey];
    this.delegatedQuestionsService.onDataChanged(this.formData);
    this.delegatedQuestionsService.setForm(this.form);
    this.delegatedQuestionsService.setGameChangeSubject(this.gameChange);
  }

  setForm(form: UntypedFormGroup) {
    this.form = form;
    if (this.delegatedQuestionsService) {
      this.delegatedQuestionsService.setForm(form);
    }
  }

  getFormData(): any {
    return this.delegatedQuestionsService.getFormData();
  }

  onDataChanged(newData: any = {}) {
    this.formData = newData;
    if (this.delegatedQuestionsService) {
      this.delegatedQuestionsService.onDataChanged(newData);
    }
  }

  getFormQuestions(params: any = {}): Observable<QuestionBase<any>[]> {
    this.setDelegatedQuestionsService(params);
    this.createQuestions(params);
    return this.questionsSubject.asObservable();
  }

  createQuestions(params) {
    this.delegatedQuestionsService
      .getFormQuestions(params)
      .subscribe((questions) => this.questionsSubject.next(questions));
  }
}
